import { render, staticRenderFns } from "./userOrderQYMsg.vue?vue&type=template&id=f516b6d6&scoped=true"
import script from "./userOrderQYMsg.vue?vue&type=script&lang=js"
export * from "./userOrderQYMsg.vue?vue&type=script&lang=js"
import style0 from "./userOrderQYMsg.vue?vue&type=style&index=0&id=f516b6d6&prod&lang=scss"
import style1 from "./userOrderQYMsg.vue?vue&type=style&index=1&id=f516b6d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f516b6d6",
  null
  
)

export default component.exports